import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function AddNewPowerOfficials() {
    const { id: power_id } = useParams(); // Get power_id from URL

    const [formData, setFormData] = useState({
        genofficial_designation: '',
        genofficial_name: '',
        genofficial_email: '',
        genofficial_phone: '',
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // ✅ Validation
    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.genofficial_designation.trim()) {
            tempErrors.genofficial_designation = 'Designation is required.';
            isValid = false;
        }
        if (!formData.genofficial_name.trim()) {
            tempErrors.genofficial_name = "Official's Name is required.";
            isValid = false;
        }
        if (
            formData.genofficial_email &&
            !/\S+@\S+\.\S+/.test(formData.genofficial_email)
        ) {
            tempErrors.genofficial_email = 'Enter a valid email address.';
            isValid = false;
        }
        setErrors(tempErrors);
        return isValid;
    };

    // ✅ Submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validate()) {
            try {
                await axios.post(`https://backend-zkgn.onrender.com/api/powergen_officials`, {
                    power_id,
                    ...formData,
                });

                setSuccessMessage('Power Generation Official Added Successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);

                setFormData({
                    genofficial_designation: '',
                    genofficial_name: '',
                    genofficial_email: '',
                    genofficial_phone: '',
                });
            } catch (error) {
                console.error('Error submitting form:', error.message);
            }
        }
    };

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Add Power Generation Plant Official</h4>

            {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row g-3">
                    {/* Designation */}
                    <div className="col-md-6">
                        <label className="form-label">Designation</label>
                        <input
                            type="text"
                            className="form-control"
                            name="genofficial_designation"
                            value={formData.genofficial_designation}
                            onChange={handleChange}
                        />
                        {errors.genofficial_designation && (
                            <small className="text-danger">{errors.genofficial_designation}</small>
                        )}
                    </div>

                    {/* Official's Name */}
                    <div className="col-md-6">
                        <label className="form-label">Official's Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="genofficial_name"
                            value={formData.genofficial_name}
                            onChange={handleChange}
                        />
                        {errors.genofficial_name && (
                            <small className="text-danger">{errors.genofficial_name}</small>
                        )}
                    </div>

                    {/* Email */}
                    <div className="col-md-6">
                        <label className="form-label">Official's Email (Optional)</label>
                        <input
                            type="email"
                            className="form-control"
                            name="genofficial_email"
                            value={formData.genofficial_email}
                            onChange={handleChange}
                        />
                        {errors.genofficial_email && (
                            <small className="text-danger">{errors.genofficial_email}</small>
                        )}
                    </div>

                    {/* Phone Number */}
                    <div className="col-md-6">
                        <label className="form-label">Phone Number (Optional)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="genofficial_phone"
                            value={formData.genofficial_phone}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Submit */}
                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary px-4">
                        Add Official
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddNewPowerOfficials;
